import { ContentTypesEnum } from "enums";
import { type AppDispatch } from "features/Application/globaltypes/redux";
import { getFilterOptions as getAssessmentFilters } from "features/Library/Assessments/state/thunks/assessmentFiltersThunk";
import { getFilterOptions as getEmbeddedVideosFilters } from "features/Library/EmbeddedVideos/state/thunks/EmbeddedVideosFiltersThunk";
import { getFilterOptions as getEventFilters } from "features/Library/Events/state/thunks/eventFiltersThunk";
import { getFilterOptions as getFlowFilters } from "features/Library/Flows/state/thunks/flowFiltersThunk";
import { getFilterOptions as getPdfsFilters } from "features/Library/Pdfs/state/thunks/pdfFiltersThunk";
import { getFilterOptions as getSurveyFilters } from "features/Library/Surveys/state/thunks/surveyFiltersThunk";
import { getFilterOptions as getVideoFilters } from "features/Library/Videos/state/thunks/videoFiltersThunk";
import { getFilterOptions as getLinkFilters } from "features/Library/ExternalLinks/state/thunks/externalLinkQueriesThunk";
import { getFilterOptions as getScheduleFilters } from "features/People/state/thunks/scheduleFiltersThunk";
import { noop } from "lodash";
import { setError, setFilterOptions, setIsLoading } from "../slices/contentAssignmentFilterSlice";

export const fetchContentAssignmentFilters = (contentType: ContentTypesEnum) => (dispatch: AppDispatch) => {
  const provider =
    <T extends (option: any, showPurchased: boolean) => Promise<void>>(action: T) =>
    (dispatch: AppDispatch) => {
      return action({ ...fetchContentAssignmentOptions(dispatch), showPurchased: true }, true);
    };

  const map: { [key in ContentTypesEnum]?: ReturnType<typeof provider> } = {
    [ContentTypesEnum.Uploaded]: provider(getVideoFilters),
    [ContentTypesEnum.Assessments]: provider(getAssessmentFilters),
    [ContentTypesEnum.PDFs]: provider(getPdfsFilters),
    [ContentTypesEnum.Embedded]: provider(getEmbeddedVideosFilters),
    [ContentTypesEnum.Surveys]: provider(getSurveyFilters),
    [ContentTypesEnum.Flows]: provider(getFlowFilters),
    [ContentTypesEnum.AllFlows]: provider(getFlowFilters),
    [ContentTypesEnum.Scheduled]: provider(getScheduleFilters),
    [ContentTypesEnum.Events]: (dispatch: AppDispatch) => {
      return dispatch(getEventFilters(fetchContentAssignmentOptions(dispatch), true, true));
    },
    [ContentTypesEnum.Links]: provider(getLinkFilters),
  };

  return contentType in map ? map[contentType]!(dispatch) : noop();
};

const fetchContentAssignmentOptions = (dispatch: AppDispatch) => {
  return {
    begin: () => dispatch(setIsLoading(true)),
    success: (options: any) => {
      dispatch(setFilterOptions(options));
      dispatch(setIsLoading(false));
    },
    failure: (error: any) => {
      dispatch(setError(error));
      dispatch(setIsLoading(false));
    },
  };
};
